<template>
  <div class="left-menu">
    <div class="btn" :class="{ active: activeRouter === 'VideoSurveillance' }" @click="pathTo('VideoSurveillance')"><i class="iconfont icon-a-shexiangtou_huaban1"></i>视频监控</div>
    <div class="btn" :class="{ active: activeRouter === 'DataExamine' }" @click="pathTo('DataExamine')">
      <i class="iconfont icon-shenhe"></i>
      数据审核
      <div class="warning-num" v-if="warningTotal > 0">
        {{ warningTotal }}
      </div>
    </div>
    <div class="btn" :class="{ active: activeRouter === 'VideoManage' }" @click="pathTo('VideoManage')"><i class="iconfont icon-yingyongguanli"></i>点位管理</div>
  </div>
</template>

<script>

export default {
  name: "LeftMenu",
  props: {
    activeRouter: { type: String, default: 'VideoSurveillance' },
    warningTotal: { type: Number, default: 0 }
  },
  data() {
    return {
      warningLength: 0
    }
  },
  mounted() {},
  methods: {
    pathTo (name) {
      if (!name) {
        return this.$message.warning('该模块开发中...')
      }
      this.$router.push({ name: name })
    }
  }
}
</script>

<style scoped lang="less">
.left-menu{
  padding: 22px 0;
  .btn{
    margin: 0 48px 26px 48px;
    cursor: pointer;
    width: 215px;
    height: 68px;
    text-align: center;
    line-height: 68px;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    background-image: url("../../../assets/img/btn.png");
    background-size: 100% 100%;
    position: relative;
    .warning-num{
      border-radius: 10px;
      background-color: #ff0000;
      min-width: 20px;
      height: 20px;
      position: absolute;
      right: -20px;
      top: -10px;
      padding: 0 5px;
      font-size: 14px;
      line-height: 20px;
    }
    i{
      font-size: 28px;
      margin-right: 10px;
    }
  }
  .active{
    width: 225px;
    margin-left: 43px;
    margin-right: 43px;
    height: 74px;
    line-height: 74px;
    background-image: url("../../../assets/img/btn-active.png");
  }
}
</style>
